import styles from './ColorCircle.module.css'

export const ColorCircle = ({ color, onClick }: { color: string; onClick?: () => any }) => {
  return <div className={styles.circle} style={{ backgroundColor: color }} onClick={onClick}></div>
}
